import React from "react";
import { DiffSegment } from "../../util/diff-util";

type Props = {
  segments: DiffSegment[];
  kind: "before" | "after";
  emptyText?: React.ReactNode;
};

export const DiffText = ({ segments, kind, emptyText = "\u00A0" }: Props) => {
  const changedStyle =
    kind === "after"
      ? {
          fontWeight: 700,
          color: "#86efac",
          background: "rgba(34, 197, 94, 0.18)",
          borderRadius: "2px",
        }
      : {
          fontWeight: 700,
          color: "#fca5a5",
          background: "rgba(239, 68, 68, 0.18)",
          textDecoration: "line-through",
          borderRadius: "2px",
        };

  if (segments.length === 0) {
    return <>{emptyText}</>;
  }

  return (
    <>
      {segments.map((seg, index) => (
        <span
          key={`${kind}-${index}`}
          style={seg.changed ? changedStyle : undefined}
        >
          {seg.text}
        </span>
      ))}
    </>
  );
};
